const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8a53f53-234a-4b01-bdbf-77dca2004ec2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.07 30.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.69,2.82A6.92,6.92,0,0,1,18.77,0,6.91,6.91,0,0,1,17.1,5.17a5.48,5.48,0,0,1-4.82,2.27A6,6,0,0,1,13.69,2.82Zm-.94,6.34c1,0,3-1.38,5.48-1.38a6.88,6.88,0,0,1,6,3,6.41,6.41,0,0,0-3.32,5.62,6.63,6.63,0,0,0,4.14,6s-2.9,7.87-6.81,7.87c-1.8,0-3.19-1.17-5.08-1.17s-3.85,1.22-5.09,1.22C4.51,30.33,0,22.86,0,16.86s3.82-9,7.4-9C9.73,7.86,11.54,9.16,12.75,9.16Z",
    style: {
      fill: "#292929",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.317785c30b94d50f98f8d02aa2ea15da.svg";
export { ForwardRef as ReactComponent };